import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import "./DashboardNew.css";
export default function DashboardNew({ panelData }) {
  useEffect(() => {
    setPanels({
      right: [
        {
          icon: <i className="fs-4 fa-solid fa-user-tie" ></i>,
          title: 'Site Visited',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(159, 59, 67, 0.44),rgb(129, 53, 53))',
          textColor: 'white',
          customClasses: '',
          data: [{ title: "Complete",data:panelData?.siteVisits?.find((elm)=>elm.status == 'Complete')?.count || 0},{ title: "Pending",data:panelData?.siteVisits?.find((elm)=>elm.status == 'Pending')?.count || 0}],
        },
        {
          icon: <i className="fs-4 fa-solid fa-diagram-project "></i>,
          title: 'Offer',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(25, 120, 37, 0.44),rgb(21, 99, 21))',
          textColor: 'white',
          customClasses: '',
          data: [{ title: "Offer Submitted",data:panelData?.offers?.find((elm)=>elm.status == 'Offer Submitted')?.count || 0},{title:"Offer Pending",data:panelData?.offers?.find((elm)=>elm.status == 'Offer Pending ')?.count || 0}],
        },
        {
          icon: <i className="fs-4 fas fa-list-check "></i>,
          title: 'Order Received',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(224, 207, 76, 0.55),rgb(217, 185, 28))',
          textColor: 'white',
          customClasses: '',
          data: [{ title: "Work in progress",data:panelData?.orders?.find((elm)=>elm.status == 'Work in progress')?.count || 0},{title:"Complete",data:panelData?.orders?.find((elm)=>elm.status == 'Complete')?.count || 0}],
        },
        {
          icon: <i className="fs-4 fa-solid fa-handshake "></i>,
          title: 'Total Handovers',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(76, 224, 98, 0.55),rgb(28, 217, 34))',
          textColor: 'white',
          customClasses: '',
          data: panelData?.totalHandovers
        },
        {
          icon: <i className="fs-4 fas fa-hourglass-end "></i>,
          title: 'Warranty Due',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right, #aa50b670, #700d91)',
          textColor: 'white',
          customClasses: '',
          data: panelData?.warrantyDue
        },
        {
          icon: <i className="fs-4 fas fa-wrench "></i>,
          title: 'AMC Due',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(72, 239, 219, 0.55),rgb(31, 233, 203))',
          textColor: 'white',
          customClasses: '',
          data: panelData?.amcDue
        },
      ],
      left: [
        {
          icon: <i className="fs-4 fa-solid fa-money-bill-trend-up" ></i>,
          title: 'New Lifts Revenue',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(54, 61, 138, 0.44),rgb(28, 47, 110))',
          textColor: 'white',
          customClasses: '',
          data: `${panelData?.orderRevenue || 0} LAC`
        },
        {
          icon: <i className="fs-4 fas fa-sack-dollar " ></i>,
          title: 'AMC’s lifts revenue',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(76, 194, 224, 0.55),rgb(28, 189, 217))',
          textColor: 'white',
          customClasses: '',
          data: `${panelData?.amcRevenue || 0} LAC`
        },
        {
          icon: <i className="fs-4 fas fa-chart-line" ></i>,
          title: 'Total Revenue',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(59, 46, 238, 0.55),rgb(28, 17, 231))',
          textColor: 'white',
          customClasses: '',
          data: `${(Number(panelData?.amcRevenue) || 0) + (Number(panelData?.orderRevenue) || 0)} LAC`,
        },
        {
          icon: <i className="fs-4 fas fa-file-contract" ></i>,
          title: 'Units In AMC',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(72, 239, 219, 0.55),rgb(31, 233, 203))',
          textColor: 'white',
          customClasses: '',
          data: panelData?.unitsInAMC
        },
        {
          icon: <i className="fs-4 fas fa-shield-halved" ></i>,
          title: 'Units In Warranty',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right, #aa50b670, #700d91)',
          textColor: 'white',
          customClasses: '',
          data: panelData?.unitsInWarranty
        },
        {
          icon: <i className="fs-4 fas fa-cogs" ></i>,
          title: 'Units In Service',
          backgroundColor: '',
          backgroundImage: 'linear-gradient(to bottom right,rgba(224, 207, 76, 0.55),rgb(217, 185, 28))',
          textColor: 'white',
          customClasses: '',
          data: `${(Number(panelData?.unitsInAMC) || 0) + (Number(panelData?.unitsInWarranty) || 0)}`
        },
      ],

    });
  }, [panelData?.newEnquires, panelData?.siteVisits, panelData?.offers, panelData?.orders, panelData?.totalHandovers, panelData?.warrantyDue, panelData?.amcDue, panelData?.orderRevenue, panelData?.amcRevenue, panelData?.unitsInAMC, panelData?.unitsInWarranty]);
  const [panels, setPanels] = useState({
    right: [
      {
        icon: <i className="fs-4 fa-solid fa-user-tie" ></i>,
        title: 'Site Visited',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(159, 59, 67, 0.44),rgb(129, 53, 53))',
        textColor: 'white',
        customClasses: '',
        data: [{ title: "Complete",data:panelData?.siteVisits?.find((elm)=>elm.status == 'Complete')?.count || 0},{ title: "Pending",data:panelData?.siteVisits?.find((elm)=>elm.status == 'Pending')?.count || 0}],
      },
      {
        icon: <i className="fs-4 fa-solid fa-diagram-project "></i>,
        title: 'Offer',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(25, 120, 37, 0.44),rgb(21, 99, 21))',
        textColor: 'white',
        customClasses: '',
        data: [{ title: "Offer Submitted",data:panelData?.offers?.find((elm)=>elm.status == 'Offer Submitted')?.count || 0},{title:"Offer Pending",data:panelData?.offers?.find((elm)=>elm.status == 'Offer Pending ')?.count || 0}],
      },
      {
        icon: <i className="fs-4 fas fa-list-check "></i>,
        title: 'Order Received',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(224, 207, 76, 0.55),rgb(217, 185, 28))',
        textColor: 'black',
        customClasses: 'text-dark',
        data: [{ title: "Work in progress",data:panelData?.orders?.find((elm)=>elm.status == 'Work in progress')?.count || 0},{title:"Complete",data:panelData?.orders?.find((elm)=>elm.status == 'Complete')?.count || 0}],
      },
      {
        icon: <i className="fs-4 fa-solid fa-handshake "></i>,
        title: 'Total Handovers',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(76, 224, 98, 0.55),rgb(28, 217, 34))',
        textColor: 'white',
        customClasses: '',
        data: panelData?.totalHandovers
      },
      {
        icon: <i className="fs-4 fas fa-hourglass-end "></i>,
        title: 'Warranty Due',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right, #aa50b670, #700d91)',
        textColor: 'white',
        customClasses: '',
        data: panelData?.warrantyDue
      },
      {
        icon: <i className="fs-4 fas fa-wrench "></i>,
        title: 'AMC Due',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(72, 239, 219, 0.55),rgb(31, 233, 203))',
        textColor: 'white',
        customClasses: '',
        data: panelData?.amcDue
      },
    ],
    left: [
      {
        icon: <i className="fs-4 fa-solid fa-money-bill-trend-up" ></i>,
        title: 'New Lifts Revenue',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(54, 61, 138, 0.44),rgb(28, 47, 110))',
        textColor: 'white',
        customClasses: '',
        data: `${panelData?.orderRevenue || 0} LAC`
      },
      {
        icon: <i className="fs-4 fas fa-sack-dollar " ></i>,
        title: 'AMC’s lifts revenue',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(76, 194, 224, 0.55),rgb(28, 189, 217))',
        textColor: 'white',
        customClasses: '',
        data: `${panelData?.amcRevenue || 0} LAC`
      },
      {
        icon: <i className="fs-4 fas fa-chart-line" ></i>,
        title: 'Total Revenue',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(59, 46, 238, 0.55),rgb(28, 17, 231))',
        textColor: 'white',
        customClasses: '',
        data: `${(Number(panelData?.amcRevenue) || 0) + (Number(panelData?.orderRevenue) || 0)} LAC`
      },
      {
        icon: <i className="fs-4 fas fa-file-contract" ></i>,
        title: 'Units In AMC',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(72, 239, 219, 0.55),rgb(31, 233, 203))',
        textColor: 'white',
        customClasses: '',
        data: panelData?.unitsInAMC
      },
      {
        icon: <i className="fs-4 fas fa-shield-halved" ></i>,
        title: 'Units In Warranty',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right, #aa50b670, #700d91)',
        textColor: 'white',
        customClasses: '',
        data: panelData?.unitsInWarranty
      },
      {
        icon: <i className="fs-4 fas fa-cogs" ></i>,
        title: 'Units In Service',
        backgroundColor: '',
        backgroundImage: 'linear-gradient(to bottom right,rgba(224, 207, 76, 0.55),rgb(217, 185, 28))',
        textColor: 'white',
        customClasses: '',
        data: `${(Number(panelData?.unitsInAMC) || 0) + (Number(panelData?.unitsInWarranty) || 0)}`
      },
    ],

  });
  // useEffect(() => {
  // }, []);
  return (
    <Container className='p-5'>
      <Row>
        <Col md={4} className='px-5'>
          <Stack gap={3}>
            {panels?.right?.map((panel, index) => (
              <div
                key={index}
                className={`shadow custom-panel d-flex align-items-center justify-content-center gap-3 py-4 ${panel?.customClasses}`}
                style={
                  {
                    backgroundColor: panel?.backgroundColor,
                    color: panel?.textColor,
                    backgroundImage: panel?.backgroundImage
                  }
                }
              >
                <span className=''>{panel?.icon}</span>
                <span>
                  <h5 className='m-0 text-center'>{panel?.title}</h5>
                  {Array.isArray(panel?.data) ?
                    <div className='d-flex gap-2'>
                      {panel?.data?.map((data, index) => (
                          <h6 key={index} title={data?.title} className=' '>{data?.data || 0} {data?.title}</h6>
                      ))}
                    </div>
                    :
                    <h5 className='m-0'>{panel?.data || 0}</h5>
                  }
                </span>
              </div>
            ))}
          </Stack>
        </Col>

        <Col md={4} className='d-flex justify-content-center align-items-center'>
          <div className='loader-wrapper' >
            {/* Spinning gradient ring */}
            <div className='loader-gradient-ring rounded-circle'></div>

            {/* Fixed content on top */}
            <div className='circle-content d-flex flex-column justify-content-center align-items-center rounded-circle'>
              <h6 className='m-0'>New Enquires</h6>
              <h3 className='m-0 fw-bolder'>{panelData?.newEnquires}</h3>
            </div>
          </div>
        </Col>

        <Col md={4} className='px-5'>
          <Stack gap={3}>
            {panels?.left?.map((panel, index) => (
              <div
                key={index}
                className='shadow custom-panel d-flex align-items-center justify-content-center gap-3 py-4'
                style={
                  {
                    backgroundColor: panel?.backgroundColor,
                    color: panel?.textColor,
                    backgroundImage: panel?.backgroundImage
                  }
                }
              >
                <span className=''>{panel?.icon}</span>
                <span>
                  <h5 className='m-0'>{panel?.title}</h5>
                  {Array.isArray(panel?.data) ?
                    <div className='d-flex gap-2'>
                      {panel?.data?.map((data, index) => (
                          <h6 key={index} title={data?.title} className=' '>{data?.data || 0} {data?.title}</h6>
                      ))}
                    </div>
                    :
                    <h5 className='m-0'>{panel?.data || 0}</h5>
                  }
                </span>
              </div>
            ))}
          </Stack>
        </Col>
      </Row>

    </Container>
  )
}
